import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const BugIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(12);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M6.55743 11.0364C6.55743 9.01383 8.19706 7.37421 10.2196 7.37421H13.7253C15.7478 7.37421 17.3875 9.01383 17.3875 11.0364V14.7613C17.3875 17.7519 14.9631 20.1763 11.9724 20.1763C8.98182 20.1763 6.55743 17.7519 6.55743 14.7613V11.0364Z" stroke="currentColor" strokeWidth="2" />;
    t1 = <path d="M11.9725 7.28632V20.3083" stroke="currentColor" strokeWidth="2" />;
    t2 = <path d="M14.7297 7.26299V6.49603C14.7297 6.12776 14.6584 5.76309 14.5198 5.42284C14.3813 5.0826 14.1782 4.77345 13.9221 4.51304C13.6661 4.25262 13.3622 4.04605 13.0276 3.90512C12.6931 3.76419 12.3346 3.69165 11.9725 3.69165C11.6104 3.69165 11.2518 3.76419 10.9173 3.90512C10.5828 4.04605 10.2788 4.25262 10.0228 4.51304C9.76676 4.77345 9.56366 5.0826 9.42509 5.42284C9.28653 5.76309 9.21521 6.12776 9.21521 6.49603V7.26299" stroke="currentColor" strokeWidth="2" />;
    t3 = <path d="M3.77045 5.47729V5.77573C3.77045 7.58003 5.23312 9.04271 7.03743 9.04271" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t4 = <path d="M3.77045 20.2821V19.9836C3.77045 18.2326 5.14802 16.8033 6.87851 16.7205" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t5 = <path d="M3.77045 12.8226H6.31084" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t6 = <path d="M20.2295 5.47729V5.77573C20.2295 7.58003 18.7668 9.04271 16.9625 9.04271" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t7 = <path d="M20.2295 20.2821V19.9836C20.2295 18.2604 18.8953 16.8488 17.2035 16.7254" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t8 = <path d="M20.2295 12.8226H17.6891" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props || $[10] !== ref) {
    t9 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = ref;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
});
export default BugIcon;